import { Typography } from '@mui/material';
import React, { FC, memo } from 'react';
import { FlexRow } from '../../basic-flex/flex-row';

interface Props {
	label: string;
	value: string;
}

export const EquipmentInfoLabelValue: FC<Props> = memo(({ label, value }) => (
	<FlexRow sx={{ gap: 1 }}>
		<Typography variant="body2" sx={{ minWidth: 160, color: 'text.secondary' }}>{label}</Typography>
		<Typography variant="body2">{value || '—'}</Typography>
	</FlexRow>
));
